import { observer } from 'mobx-react';
import { ExperienceResource } from '../../Experience/Types';
import ProgramTimeCommitment from './ProgramTimeCommitment';
import ExperienceProductDetails from './ExperienceProductDetails';

interface Props {
  experienceResource: ExperienceResource;
}

function ExperienceTimeCommitmentItems({ experienceResource }: Props) {
  switch (experienceResource.payload.offeringType) {
    case 'aep':
    case 'epc':
    case 'msuite':
      return <ProgramTimeCommitment experienceResource={experienceResource} />;
    case 'coaching':
    case 'group-coaching':
    case 'program-sequence':
      return <ExperienceProductDetails experienceResource={experienceResource} />;
  }
}

export default observer(ExperienceTimeCommitmentItems);
